import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ReportsComponent } from '../erp/reports/reports.component';
import { SharedDataService } from '../../@core/service/shared-data.service';
import { ContactUtil } from '../erp/shared/doc-form-address-selector/doc-form-address-selector.component';
import { ApiService } from '../../@core/service/api.service';
import { getDocumentNumber, mongoId, waitForVariable } from '../../@core/common/global';
import { EBusinessType, EContactType } from '../../@models';
import { CompilationTypeData, DocConfig, PackingStatusData } from '../../@models/erp/compilationData';
import { ReportsPrinterComponent } from '../erp/reports/reports-printer/reports-printer.component';
import { EWarehousingEntryType, WarehousingModel } from '../../@models/warehousing';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { NbToastrService } from '@nebular/theme';
import { NrkWindowComponent } from '../erp/shared/nrk-window/nrk-window.component';
import { CompilationModel } from '../../@models/erp/compilation';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { SelectorDisplayMode } from '../erp/document/document-select/document-select.component';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../@core/service/eventService';
import * as moment from 'moment';
import { DownloadConfig } from '../erp/document/document-printer/document-printer.component';
import * as saveAs from 'file-saver';
import { PopupDocumentComponent } from '../erp/document/document-printer/popup-document/popup-document.component';
import { HeaderComponent } from '../../@theme/components';


@Component({
  selector: 'warehousing',
  templateUrl: './warehousing.component.html',
  styleUrls: ['./warehousing.component.scss']
})
export class WarehousingComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('reportsPrinterComp') reportsPrinterComp: ReportsPrinterComponent;
  @ViewChild('coverSheet') coverSheet: ElementRef<HTMLDivElement>;


  protected selectorDisplayMode = SelectorDisplayMode;

  search: any;

  nrkInfoOpacity = 1;
  nrkaInfo = '';

  csOptions = [];

  shipment = null;

  documentNumberOptions: IMultiSelectOption[]

  subscriptions = [];

  reportData: any;
  docCodes = [];
  currentDocuments: CompilationModel[] = []; 

  filter = {
    notReadyForPacking: true,
    readyForPacking: true,
    readyForDispatch: true,
    dispatched: false,
    delivered: false,
    openOrders: false,
    // delNotInvoiced: true,
  }
  showFilters = false;

  constructor (
    protected data: SharedDataService,
    private api: ApiService,
    private cdRef: ChangeDetectorRef,
    private auth: AuthGuardService,
    private toast: NbToastrService,
    private route: ActivatedRoute,
    private event: EventService,
  ) {}

  async ngOnInit(): Promise<void> {

    this.data.loadCompilationData();
    this.data.loadUsers();
    await this.data.loadBusinesses();

    this.data.loadBusinessUnits().then(bu => {
      this.search = { deliverynotes: {} as any };
      this.search.deliverynotes = { ...ReportsComponent.defaultReport.noninvoiced } as any;
      this.search.deliverynotes.filterInternal = true;
      this.search.deliverynotes.businessUnits = bu.filter(f => ['EM', 'CO', 'AD', 'MM', 'VI', 'BA'].includes(f.code)).map(m => m._id);
      // this.search.deliverynotes.sampleRequest = 1;
      this.search.deliverynotes.showRelatedPFSPOs = true;
      this.search.deliverynotes.noPrices = true;
      this.search.deliverynotes.sortType = 1;
      this.search.deliverynotes.documentNumbers = []
      this.search.deliverynotes.placeOfLoading = this.data.business.jerich?._id;
      this.search.deliverynotes.dateTo = moment().endOf('isoWeek').add(2, 'weeks').toDate();
      // this.search.deliverynotes.withoutProveOfDelivery = true;
    })

    await this.data.loadBusinesses();
    const contactUtil = new ContactUtil(this.data);
    const contactsTmp = this.api.reloadContacts({ type: EBusinessType.NRK, contactType: EContactType.Employee, business: mongoId(this.data.business.nrka) })
    const subscr = contactsTmp.subscribe(contacts => {
      const contact = contacts.find(f => f.title === 'Rene Kurita');
      this.nrkaInfo = 
          contactUtil.getAddressFromBusiness(this.data.business.nrka) + '\n\n'
        + contactUtil.getContactInfo(contact, DocConfig.get('recipientContact').fields);
      subscr.unsubscribe();
    })

    this.api.getDocumentNumbers([CompilationTypeData.get('DN').id], [2]).then(docs => {  // status = final
      this.documentNumberOptions = [...docs.map(m => ({id: m.code, name: m.code + 'VS' + m.version}))]
    });

    this.api.getCsOptions().then(opts => {
      console.log('opts', opts);
      this.csOptions = opts.map(m => ({ id: m.code, name: getDocumentNumber(m) })) // [{ id: null, name: '---- All ----'}, ...opts]
    }
    );

    this.data.loadWarehousing();
  }

  ngAfterViewInit(): void {
    this.loadMessage();
    this.subscriptions.push(this.event.showMessage.subscribe(msg => {
      this.loadMessage(msg);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onScroll(data) {
      const scrollPosition = data.scrollbox.nativeElement.scrollTop;
      this.nrkInfoOpacity = scrollPosition < 50 ? 1 : 0
      this.cdRef.detectChanges();
  }

  reloadData() {
    // this.search.deliverynotes.showAll = this.search.deliverynotes.customers.length > 0;
    this.reportsPrinterComp.reloadData();
  }


  filterByCombinedShipment(cs: any) {
    this.search.deliverynotes.combinedShipments = [cs.code]
    this.shipment = cs;
  }

  reportLoaded(data: any) {
    this.reportData = data;
    this.loadMessage();
  }

  async loadMessage(msg = null) {
    const messageId = this.route.snapshot.queryParams.message;
    if (messageId || msg) {
      await this.data.loadWarehousing();
      const message = msg ? msg : this.data.warehousingMessages.find(f => mongoId(f) === messageId);
      // const code = this.route.snapshot.queryParams.code;
      console.log('report loaded', message.code, message);
      if (this.reportsPrinterComp) {
        this.reportsPrinterComp.scrollToDoc(message.code);
        this.reportsPrinterComp.openMessage(message);
      }
    }
  }

  onDocCodes(codes: string[]) {
    // console.log('pdf data', this.reportData.pdfData, this.reportData.pdfData.filter(f => f.packingStatus === PackingStatusData.get('packingReady').id));
    // const packingReady = this.reportData.pdfData.filter(f => f.packingStatus === PackingStatusData.get('packingReady')).map(m => m.code);
    //this.docCodes = codes //.filter(f => packingReady.includes(f));
    this.docCodes = this.reportData?.pdfData.filter(f => f.packingStatus === PackingStatusData.get('packingReady').id).map(m => m.code) || [];
    // console.log('doc codes', this.docCodes);
  }

  async printAllPackingInstructions() {

    console.log('printAllPackingInstructions current codes', this.docCodes);

    this.currentDocuments = await this.api.loadCompilationsByCodes(this.docCodes);

    this.cdRef.detectChanges();

    await new Promise(res => window.setTimeout(() => res(true), 3000));

    const allHtml = this.coverSheet.nativeElement;

    for (const doc of this.currentDocuments) {

      const config = new DownloadConfig();
      config.css = 'document-printer.css';
      config.footer = '';
      
      config.html = allHtml.querySelector('#doc_' + doc.code).innerHTML; // this.coverSheet.innerHTML;
      config.orientation = 'portrait';
  
      await new Promise(resolve => this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
  
        const date = moment(doc.issueDate ? doc.issueDate : new Date()).format('YYMMDD');
        const docnum = getDocumentNumber(doc);
        const company = this.data.businesses.find(f => mongoId(f) === mongoId(doc.recipient))?.name
        if (res.size) saveAs(res, `${date}_${company}_${docnum}_Packing_information.pdf`);
        PopupDocumentComponent.addWarehousingLog(doc, this.data, this.api, this.auth, 'Print Packing Information');
        resolve(true);
  
      }));
  
    }

    // this.currentDocuments = [];
  }


}

